import { render, staticRenderFns } from "./Lvyouyulun.vue?vue&type=template&id=4c2c59ad&scoped=true&"
import script from "./Lvyouyulun.vue?vue&type=script&lang=js&"
export * from "./Lvyouyulun.vue?vue&type=script&lang=js&"
import style0 from "./Lvyouyulun.vue?vue&type=style&index=0&id=4c2c59ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c59ad",
  null
  
)

export default component.exports